export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
      align:'center'

    },
    {
      key: 'museumname',
      slot: 'museumname',
      title: '博物馆名称',
      align:'center',
      width:300
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
      align:'center',
      width: 80,
    },
    {
      key: 'votesum',
      dataIndex: 'votesum',
      title: '得票数',
      align:'center'

    },
    {
      key: 'textsum',
      dataIndex: 'textsum',
      title: '文字项个数',
      align:'center'

    },
    {
      key: 'filesum',
      dataIndex: 'filesum',
      title: '附件个数',
      align:'center'

    },
    {
      key: 'referee',
      dataIndex: 'referee',
      title: '推荐人',
      align:'center'
    },
    {
      title: '投票人',
      slot:'operatehz',
      align:'center'
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  },
};
export const tableData1 = {
  tHead: [
    {
      title: '序号',
      slot:'index',
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '投票人',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '第一家博物馆',
    },
    {
      key: 'score1',
      dataIndex: 'score1',
      title: '得票数',
    },
    {
      key: 'score2',
      dataIndex: 'score2',
      title: '第二家博物馆',
    },
    {
      key: 'score3',
      dataIndex: 'score3',
      title: '得票数',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
